import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

// Async thunk to fetch the vendor dropdowns
export const fetchVendorDropdowns = createAsyncThunk(
  "vendor/fetchVendorDropdowns",
  async (_, thunkApi) => {
    try {
      const response = await client.get(ENDPOINTS.getVendorDropdowns);
      console.log("response", response.data);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  dropdowns: [],
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Create the slice
const vendorDropdownSlice = createSlice({
  name: "vendorDropdowns",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorDropdowns.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVendorDropdowns.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("action.payload", action.payload);

        state.dropdowns = action.payload || [];
      })
      .addCase(fetchVendorDropdowns.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default vendorDropdownSlice.reducer;
